// Тексты и мелочи для рейтинга исполнителя (данные — с сервера, rating.js)
import moment from 'moment'

export const LEVEL_COLORS = { low: '#DB5151', mid: '#F2994A', good: '#00A597', high: '#03A0E3' }
export const levelColor = (level) => LEVEL_COLORS[level] || LEVEL_COLORS.mid

export const plural = (n, one, few, many) => {
    const a = Math.abs(n) % 100
    const b = a % 10
    if (a > 10 && a < 20) return many
    if (b > 1 && b < 5) return few
    if (b === 1) return one
    return many
}
// «5 дней», «2 дня»
export const daysText = (n) => n + ' ' + plural(n, 'день', 'дня', 'дней')
// «больше 3 дней», «больше 1 дня»
const daysGenitive = (n) => n + ' ' + (n % 10 === 1 && n % 100 !== 11 ? 'дня' : 'дней')
// +4, −10, 0
export const signed = (n) => (n > 0 ? '+' : n < 0 ? '−' : '') + Math.abs(n)

export const RATING_PROMISE = 'Чем выше рейтинг, тем больше заказов вы получаете. С низким рейтингом дорогие задания не выдаются.'
export const RATING_LOW_WARNING = 'Низкий рейтинг — дорогие задания вам не выдаются. Заходите в приложение каждый день и отвечайте строго по заданию, чтобы рейтинг рос.'
export const BAD_ANSWER_ADVICE = 'Чем выше рейтинг, тем больше заказов, а с низким рейтингом дорогие задания не выдаются. Отвечайте строго по заданию — тогда рейтинг будет только расти.'
export const CUSTOMER_DOWN_ADVICE = 'Чем выше рейтинг, тем больше заказов, а с низким рейтингом дорогие задания не выдаются. Выполняйте задания точно по инструкции и вежливо отвечайте заказчикам — тогда рейтинг будет только расти.'

// Как меняется рейтинг — числа с сервера (их можно поменять в настройках)
export function rulesList(r) {
    if (!r) return []
    return [
        { delta: '+' + r.daily, text: 'каждый день, когда вы заходите в приложение' },
        { delta: '+' + r.week_bonus, text: 'за каждые ' + daysText(r.week_days) + ' подряд' },
        { delta: '−' + r.bad_answer, text: 'если заказчик отметит ваш ответ как «чушь»', bad: true },
        r.customer_down ? { delta: '−' + r.customer_down, text: 'если заказчик, с которым вы переписываетесь, понизит рейтинг (один раз)', bad: true } : null,
        { delta: '−' + r.decay_per_day, text: 'в день, если не заходить больше ' + daysGenitive(r.grace_days), bad: true }
    ].filter(Boolean)
}

export const formatWhen = (at) => {
    const m = moment(at)
    return m.isValid() ? m.format('D MMM, HH:mm') : ''
}

// Строка истории: { title, sub, delta, muted }
export function historyLine(h) {
    if (h.reason === 'customer') {
        return { title: 'Заказчик понизил рейтинг', sub: h.order_name ? '«' + h.order_name + '»' : '', delta: h.delta, muted: false }
    }
    if (h.reason === 'bad_answer') {
        return {
            title: '«Чушь в ответе»',
            sub: h.reverted ? 'Отменено — заказчик принял ответ' : (h.order_name ? '«' + h.order_name + '»' : 'Заказчик отклонил ответ'),
            delta: h.delta,
            muted: !!h.reverted
        }
    }
    const parts = []
    if (h.streak > 1) parts.push('🔥 ' + daysText(h.streak) + ' подряд')
    if (h.week > 0) parts.push('неделя подряд ' + signed(h.week))
    if (h.decay > 0) parts.push('не заходили ' + daysText(h.missed_days) + ': ' + signed(-h.decay))
    ;(h.achievements || []).forEach((a) => parts.push(a.icon + ' ' + a.title))
    return { title: 'Вход в приложение', sub: parts.join(' · '), delta: h.delta, muted: false }
}
